import {components, ControlProps} from 'react-select';
import {memo, ReactNode} from 'react';
import {Typography} from 'components/Typography';
import style from '../style.module.scss';
import {ISelectOption} from '..';

interface IProps {
    controlInfoTooltip?: ReactNode;
    multiple: boolean;
}

export const CustomControl = memo<IProps & ControlProps>(
    ({controlInfoTooltip, multiple, children, selectProps, ...props}) => {
        return (
            <components.Control className={style.control} selectProps={selectProps} {...props}>
                {multiple ? (
                    <>
                        {0 < (selectProps.value as unknown as ISelectOption<string>[])?.length && (
                            <>
                                <Typography className={style.prefixText}>Напиток:</Typography>
                                &nbsp;
                            </>
                        )}
                        <Typography className={style.controlText}>{children}</Typography>
                    </>
                ) : (
                    <>
                        {children}
                        {controlInfoTooltip}
                    </>
                )}
            </components.Control>
        );
    },
);
